export const UPDATE_FEED = 'UPDATE_FEED';
export const RESET_FEED = 'RESET_FEED';
export const GET_FEED_POSTS = 'GET_FEED_POSTS';
export const ADD_FEED_POST = 'ADD_FEED_POST';
export const UPDATE_FEED_POST = 'UPDATE_FEED_POST';
export const DELETE_FEED_POST = 'DELETE_FEED_POST';
export const SET_FEED_ANCHOR = 'SET_FEED_ANCHOR';
export const ADD_ANNOUNCEMENT = 'ADD_ANNOUNCEMENT';
export const SET_IS_CONFIRMED_ANNOUNCEMENT_POPOVER = 'SET_IS_CONFIRMED_ANNOUNCEMENT_POPOVER';
